import type { ReactNode } from "react";

/** Shared layout for the privacy, terms and refund pages. */
export function LegalPage({
  title,
  summary,
  children,
}: {
  title: string;
  summary: string;
  children: ReactNode;
}) {
  return (
    <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
      <header>
        <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl">{title}</h1>
        <p className="mt-3 text-sm text-muted-foreground">{summary}</p>
        <p className="mt-2 text-[11px] uppercase tracking-[0.2em] text-muted-foreground">
          Last updated 12 September 2026
        </p>
      </header>
      <div className="mt-10 space-y-8">{children}</div>
    </div>
  );
}

export function LegalSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="rounded-xl border border-[var(--glass-border)] bg-card p-5 sm:p-6">
      <h2 className="text-sm font-semibold text-gold">{title}</h2>
      <div className="legal-body mt-3 space-y-3 text-xs leading-relaxed text-muted-foreground">
        {children}
      </div>
    </section>
  );
}
